import React, { useState, useEffect } from "react";

import { Typography, FormControlLabel, Checkbox } from "@mui/material";

import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CustomInput from "components/CustomInput/CustomInput";

import SwitchLeftRightOptions from "components/shared/SwitchLeftRightOptions";

import { RegisterButtons } from "views/MyApps/RegisterButtons";

export function NewAppBody(props) {
  const { setRegisterButtonDisabled } = props;

  const [formValues, setFormValues] = useState({
    appName: "",
    applicationType: false,
    agreedToTos: false,
  });

  function handleChange(event) {
    const { id, value } = event.target;
    if (id === "applicationType") {
      setFormValues({
        ...formValues,
        applicationType: !formValues.applicationType,
      });
    } else if (id === "agreedToTos") {
      setFormValues({
        ...formValues,
        agreedToTos: event.target.checked ? true : false,
      });
      setRegisterButtonDisabled(
        formValues.appName === "" || !event.target.checked
      );
    } else {
      setFormValues({ ...formValues, [id]: value });
      if (id === "appName") {
        setRegisterButtonDisabled(value === "" || !formValues.agreedToTos);
      }
    }
  }

  useEffect(() => {
    setRegisterButtonDisabled(true);
  }, [setRegisterButtonDisabled]);

  return (
    <Card>
      <CardBody>
        <CustomInput
          labelText="Application name..."
          id="appName"
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            type: "text",
            required: true,
            value: formValues.appName,
            onChange: handleChange,
          }}
        />
        <p>
          Indicate below whether this is an app being developed for one or more
          specific SOS customers, or it is being developed for marketing to any
          SOS customer.
        </p>
        <SwitchLeftRightOptions
          leftOption="specific customer"
          rightOption="for any customer"
          id="applicationType"
          checked={formValues.applicationType}
          onChange={() => handleChange}
        />
        <br />
        <FormControlLabel
          control={
            <Checkbox
              id="agreedToTos"
              color="primary"
              checked={formValues.agreedToTos}
              onChange={handleChange}
            />
          }
          label={
            <Typography variant="body2" style={{ fontSize: "0.875rem" }}>
              I have read, and agree to, the{" "}
              <a
                href="https://www.sosinventory.com/terms-of-service"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </a>
              .
            </Typography>
          }
          labelPlacement="start"
          style={{ marginLeft: 0 }}
        />
      </CardBody>
      <RegisterButtons
        user={props.user}
        createApp={props.registerApp}
        appName={formValues.appName}
        applicationType={formValues.applicationType}
        registerButtonDisabled={props.registerButtonDisabled}
        setCrudState={props.setCrudState}
      />
    </Card>
  );
}
